import { FieldValues } from 'react-hook-form'

export interface Pagination {
    page_size: number
    page: number
}

export interface DOGridPayLoad extends Pagination {
    q?: string
    filters: string
}

export enum DayOffType {
    normal = 'normal',
    annual_leave = 'annual_leave',
}

export interface DayOffNewPayload extends FieldValues {
    day_off: {
        day_off_range_time: DayOffRangeTime[]
        day_off_reason: string
        day_off_type: DayOffType
    }
}

export interface DayOffRangeTime {
    start_day_off: string
    day_off_option: number
}

export interface DayOffBODApprove {
    day_off_feedback_bod: string
}

export interface DayOffLeaderApprove {
    day_off_feedback_lead: string
}

export interface DayOffReject {
    day_off_feedback: string
}

export interface DayOffUpdate {
    day_off: {
        day_off_range_time: DayOffRangeTime[]
        day_off_reason: string
    }
}
